import { useCallback, useMemo } from 'react';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import {
  updateUsers,
  updateRoles,
  updateAccesses,
  fetchUsersData,
  fetchRolesData,
  fetchAccessesData,
} from 'src/redux/slice/user';

// ----------------------------------------------------------------------

export default function useUsers() {
  const dispatch = useDispatch()

  const users = useSelector((state) => state.user.allData)
  const accesses = useSelector((state) => state.user.accesses)
  const roles = useSelector((state) => state.user.roles)
  const isLoading = useSelector((state) => state.user.isLoading)
  const error = useSelector((state) => state.user.error)

  const onRefreshUsers = useCallback(
    (idUser) => {
      dispatch(fetchUsersData({ idUser }))
        .unwrap()
    },
    [dispatch],
  )

  const onRefreshAccesses = useCallback(
    (idUser) => {
      dispatch(fetchAccessesData({ idUser })).unwrap();
    },
    [dispatch]
  );


  const onRefreshRoles = useCallback(
    (idUser) => {
      dispatch(fetchRolesData({ idUser })).unwrap();
    },
    [dispatch]
  );

  const onInitUsers = useCallback(
    (idUser) => {
      if (idUser) {
        onRefreshUsers(idUser);
        onRefreshRoles(idUser);
        onRefreshAccesses(idUser);
      }
    },
    [onRefreshAccesses, onRefreshRoles, onRefreshUsers]
  );

  const onUpdateUsers = useCallback(
    (data) => {
      dispatch(updateUsers({ data }));
    },
    [dispatch]
  );

  const onUpdateRoles = useCallback(
    (data) => {
      dispatch(updateRoles({ data }));
    },
    [dispatch]
  );

  const onUpdateAccesses = useCallback(
    (data) => {
      dispatch(updateAccesses({ data }));
    },
    [dispatch]
  );

  // Memoized return value for performance
  return useMemo(
    () => ({
      allUsers: users,
      accesses,
      roles,
      isLoading,
      error,
      onRefreshUsers,
      onInitUsers,
      onUpdateUsers,
      onUpdateRoles,
      onUpdateAccesses,
      onRefreshAccesses,
      onRefreshRoles,
    }),
    [
      users,
      accesses,
      roles,
      isLoading,
      error,
      onRefreshUsers,
      onInitUsers,
      onUpdateUsers,
      onUpdateRoles,
      onUpdateAccesses,
      onRefreshAccesses,
      onRefreshRoles,
    ]
  );
}
